<div class="sidenav-menu-outer" [perfectScrollbar]="psConfig" [disabled]="settings.fixedSidenavUserContent">
	<div fxLayout="column" fxHide fxShow.gt-sm fxLayoutAlign="center center" class="user-block" [class.py-3]="settings.menuType != 'mini'" [class.py-2]="settings.menuType == 'mini'">
		<!-- <app-profile-pic [allowUpload]="true"></app-profile-pic> -->

		<app-profile-pic></app-profile-pic>

		<h2 *ngIf="settings.menuType != 'mini'" class="mt-2">{{fullName}}</h2>
		<p *ngIf="settings.menuType == 'default'" class="secondary-text-color">{{menuService.userProfile.email}}</p>
		<p *ngIf="settings.menuType == 'default' && menuService.userProfile.loginProvider" class="secondary-text-color"><i>{{menuService.userProfile.loginProvider}}</i></p>
	</div>
	<mat-divider></mat-divider>
	<div id="vertical-menu" [perfectScrollbar]="psConfig" [disabled]="!settings.fixedSidenavUserContent">
		<app-vertical-menu *ngIf="activeModule" [menuParentId]="activeModule.id" [menus]="menuItems"></app-vertical-menu>
	</div>
</div>